function verticalSlider() {
  $(document).ready(function() {
    if ($('#vertical_slider').length) {

      let splideSlider = new Splide('#vertical_slider', {
        type: 'slide',
        perPage: 1,
        direction: 'ttb',
        pagination: false,
        arrows: false,
        drag: false,
        height: '617px',
      });

      splideSlider.mount();

      const wrapper = document.querySelector('.vertical-slider-wrapper');
      const slider = document.querySelector(
          '.paragraph--type--vertical-scroll-slider');

      if (!wrapper || !slider) {
        return;
      }

      const slidesCount =
          slider.querySelectorAll('.splide__slide').length;

      if (slidesCount <= 1) {
        return;
      }


      function updateWrapperHeight() {
        wrapper.style.height =
            `${(slidesCount - 1) * window.innerHeight + slider.offsetHeight}px`;
      }

      let currentSlide = 0;
      let lastHeaderHeight = 0;
      const header = document.querySelector('.content-header');
      function checkPosition() {

        const wrapperRect = wrapper.getBoundingClientRect();

        const header = document.querySelector('.content-header');

        const headerHeight = header
            ? header.clientHeight
            : 0;

        if (headerHeight !== lastHeaderHeight) {
          slider.style.top = `${headerHeight}px`;
          lastHeaderHeight = headerHeight;
        }

        const scrollInside =
            Math.max(0, headerHeight - wrapperRect.top);


        const maxScroll =
            Math.max(
                wrapper.offsetHeight - window.innerHeight,
                1
            );

        const progress =
            Math.min(scrollInside / maxScroll, 1);

        const slideIndex =
            Math.min(
                Math.floor(progress * slidesCount),
                slidesCount - 1
            );

        if (slideIndex !== currentSlide) {
          currentSlide = slideIndex;
          splideSlider.go(slideIndex);
        }
      }

      window.addEventListener('scroll', checkPosition);

      updateWrapperHeight();

      window.addEventListener('resize', updateWrapperHeight);

      checkPosition();
    }
  });
}
